export default __webpack_public_path__ + "static/media/james-bond-quiz.03b70ea8.jpg";